






















































import axios from 'axios';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
    CatalogOrderViewModel,
    Catalog,
} from '@/models/Catalog';
import { CustomField, CustomFieldData } from '@/models/Contact';
import DynamicForm from '@/components/Form/DynamicForm.vue';
import { websiteText } from '@/mixins/websiteTexts';

import http from '@/services/Http';

@Component({
    components: {
        DynamicForm
    }
})
export default class CatalogOrder extends Vue {
    protected viewModel: CatalogOrderViewModel;
    protected selectedCatalogs: string[] = [];
    protected isLoaded: boolean = false;
    protected isSubmitted: boolean = false;
    protected errorMsgs: string[] = [];

    constructor() {
        super();
        this.viewModel = JSON.parse(this.$attrs['data-content']);
        this.$attrs['data-content'] = '';
    }

    websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    mounted() {
        this.updateSelected();
    }

    private updateSelected() {
        this.selectedCatalogs = [];

        this.viewModel.Catalogs.forEach(element=> {
            if (element.Selected == true) {
                this.selectedCatalogs.push(element.Title);
            }
        });
    }
    
    get formSchema(): CustomField[] {
        return [
            { placeholder: websiteText('retailer.firstname'), fieldType: 'TextField', mandatory: true, tabIndex: 1 },
            { placeholder: websiteText('retailer.lastname'), fieldType: 'TextField', mandatory: true, tabIndex: 2 },
            { placeholder: websiteText('retailer.emailaddress'), fieldType: 'EmailField', mandatory: true, tabIndex: 3 },
            { placeholder: websiteText('retailer.address'), fieldType: 'TextField', mandatory: true, tabIndex: 4 },
            { placeholder: websiteText('retailer.zipcode'), fieldType: 'TextField', mandatory: true, tabIndex: 5 },
            { placeholder: websiteText('retailer.city'), fieldType: 'TextField', mandatory: true, tabIndex: 6 },
            { placeholder: websiteText('retailer.country'), fieldType: 'TextField', mandatory: true, tabIndex: 7 },
            { 
                placeholder: websiteText('general.approve'), 
                fieldType: 'CheckboxField', 
                options: [{ text: websiteText('site.policy'), value: 'true' }], 
                mandatory: true, 
                tabIndex: 8 
            }
        ];
    }

    private submitForm(formData: CustomFieldData[]) {
        this.errorMsgs = [];

        if (this.selectedCatalogs.length === 0) {
            this.errorMsgs.push(websiteText('custom.AtLeastOneRequierdFieldIsMissing'));
            return;
        }

        this.isSubmitted = true;

        const request = {
            Catalogs: this.selectedCatalogs,
            FirstName: formData[0].value,
            LastName: formData[1].value,
            Mail: formData[2].value,
            Address: formData[3].value,
            ZipCode: formData[4].value,
            City: formData[5].value,
            Country: formData[6].value,
            ConcentPolicy: formData[7].value === 'true',
        };

        const requestContext = (window as any).__litium.requestContext;

        axios({
            method: 'post',
            url: `/api/catalogorder`,
            data: request,
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
        .then((response: any) => {
            const self = this;
            setTimeout(function() {
                self.isLoaded = true;
                self.isSubmitted = false;
            }, 600);
        })
        .catch((response: any) => {
            this.isSubmitted = false;
            this.errorMsgs.push('Ett fel uppstod. Vänligen försök igen.');
        });
    }
}
